import { isEmpty, reduce } from 'lodash'

export const filterDisabledOperatingHours = (operatingHours) => {
  return reduce(
    operatingHours,
    (res, days, index) => {
      const day = days.filter((day) => day?.disabled === false)

      if (!isEmpty(day)) {
        return { ...res, [index]: day }
      } else {
        return { ...res }
      }
    },
    {}
  )
}
